/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DownloadManagementListContentResponse } from './DownloadManagementListContentResponse';

export type DownloadManagementListContentResponseApiRespoonse = {
    data?: DownloadManagementListContentResponse;
    status?: DownloadManagementListContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace DownloadManagementListContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

